import axios from "axios";

// Base API URL
const API_URL = "https://goodwillglobalsolutions.com/api";

const api = axios.create({
  baseURL: API_URL,
});

// REQUEST INTERCEPTOR: Add token automatically
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// RESPONSE INTERCEPTOR: Handle token errors globally
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token invalid or expired
      localStorage.removeItem("token"); // remove invalid token
      alert("Session expired or token failed Plese login again")
      window.location.href = "/login"; // redirect to login
    }
    return Promise.reject(error);
  }
);

export default api;